module.exports = new __parcel__URL__("benefits_1.ecf79e7d.webp").toString();